import { createStore, action } from 'easy-peasy'

import model from './model/index'

export const store = createStore({
  ...model,
  reset: action(() => ({ ...model }))
})
